import Page from './Page';
import Component from 'vue-class-component';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';

import template from './Code.vue.html';
@Component({ template, components: { TabBar, HeaderComponent } })
export default class Code extends Page {}
